export const PERSIST_KEYS = {
  USE_CASE: 'use_case',
  ACCOUNTS_IDS: 'accounts_ids',
  AUTH_SIGNAL: 'auth_signal',
  IMAGE_GENERATION_STATE: 'image_generation_state',
  ONBOARDING_STATE: 'onboarding_state',
};
